import { SardineConfigBase, SardineUpdateConfig } from './config';

type DeviceResponse = {
  deviceId: string; // UUID format
  deviceToken: string; // UUID format
};

let baseConfig: SardineConfigBase = { clientId: '', environment: 'sandbox', region: 'default' };
let config: SardineUpdateConfig | undefined;
let sardineContext: any | undefined;
let deviceData: DeviceResponse | undefined;

const setBaseConfig = (params: SardineConfigBase) => {
  if (params) {
    baseConfig = { ...params };
  }
};
const getBaseConfig = (): SardineConfigBase => baseConfig;

const setConfig = (params: SardineUpdateConfig) => {
  if (params) {
    config = { ...params };
  }
};
const getConfig = () => config;

const setContext = (context: any) => {
  if (context) {
    sardineContext = context;
  }
};
const getDeviceData = (): DeviceResponse | undefined => deviceData;

const setDeviceData = (data: DeviceResponse) => {
  if (data) {
    deviceData = data;
  }
};
const getContext = (): any | undefined => sardineContext;

const getSardineHost = () => {
  const { environment, region } = getBaseConfig();
  const isSandbox = environment === 'sandbox';
  var regionValue = region === 'default' ? '' : region || '';
  regionValue = regionValue ? `${regionValue}.` : '';

  return isSandbox ? `api.sandbox.${regionValue}sardine.ai` : `api.${regionValue}sardine.ai`;
};

export {
  setBaseConfig,
  getBaseConfig,
  setConfig,
  getConfig,
  setContext,
  getContext,
  getDeviceData,
  setDeviceData,
  getSardineHost,
};
